import { WorkoutSportType } from '../../types/sport.type';

export const ZWO_RAMP_STEP_SECONDS: number = 30;
export const ZWO_FREE_RIDE_POWER: number = 0.5;
export const ZWO_ZONE_POWER: Readonly<Record<number, number>> = {
  1: 0.5,
  2: 0.68,
  3: 0.83,
  4: 0.98,
  5: 1.13,
  6: 1.3,
};
export const ZWO_SPORT_TYPES: Readonly<Record<string, WorkoutSportType>> = {
  bike: 'cycling',
};
